enum Currency {
  USD = 'USD',
  GBP  = 'GBP',
  SEK = 'SEK',
  JPY = 'JPY',
}
const DEFAULT_CURRENCY = Currency.USD;
export { Currency, DEFAULT_CURRENCY };
